var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "profile-container" }, [
    _c("div", { staticClass: "page-header-container" }, [
      _c(
        "div",
        { staticClass: "page-header" },
        [
          _c("span", { staticClass: "page-title" }, [
            _vm._v(_vm._s(_vm.$t("user.profile.title"))),
          ]),
          _vm._v(" "),
          _c("FormActionBtns", {
            staticClass: "action-btns",
            attrs: { hiddenAdd: true, onCancel: _vm.cancel, onSave: _vm.save },
            model: {
              value: _vm.status,
              callback: function ($$v) {
                _vm.status = $$v
              },
              expression: "status",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "profile-main" }, [
      _c("div", { staticClass: "profile-basic" }, [
        _c("div", { staticClass: "profile-section-title" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("user.profile.basicInformation")) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "profile-item" }, [
          _c("label", { staticClass: "emphasis" }, [
            _vm._v(_vm._s(_vm.$t("user.fullName"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "label-content" }, [
            _vm._v(_vm._s(_vm.userName(_vm.currentUser))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "profile-item" }, [
          _c("label", { staticClass: "emphasis" }, [
            _vm._v(_vm._s(_vm.$t("username"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "label-content" }, [
            _vm._v(_vm._s(_vm.currentUser.username)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "profile-item" }, [
          _c("label", { staticClass: "emphasis" }, [
            _vm._v(_vm._s(_vm.$t("position"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "label-content" }, [
            _vm._v(_vm._s(_vm.currentUser.title || _vm.$t("na"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "profile-item" }, [
          _c("label", { staticClass: "emphasis" }, [
            _vm._v(_vm._s(_vm.$t("userType.name"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "label-content" }, [
            _vm._v(_vm._s(_vm.$t(_vm.userType))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "profile-item" }, [
          _c("label", { staticClass: "emphasis" }, [
            _vm._v(_vm._s(_vm.$t("user.phone"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "label-content" }, [
            _vm._v(_vm._s(_vm.primaryContactPhoneNumber || _vm.$t("na"))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "profile-account-and-dashboard" }, [
        _c(
          "div",
          { staticClass: "profile-account" },
          [
            !_vm.globalOptionsReady
              ? [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("loading")) + "\n        "
                  ),
                ]
              : [
                  _c("div", { staticClass: "profile-section-title" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("user.profile.accountInformation")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "profile-item" },
                    [
                      _c("label", { staticClass: "emphasis" }, [
                        _vm._v(_vm._s(_vm.$t("user.profile.defaultRegion"))),
                      ]),
                      _vm._v(" "),
                      !_vm.isEdit
                        ? _c("span", { staticClass: "label-content" }, [
                            _vm._v(_vm._s(_vm.selectedRegion.name)),
                          ])
                        : _c("HKLSelect", {
                            attrs: {
                              value: _vm.selectedRegionId,
                              options: _vm.regionHklOptions,
                              showSearch: true,
                              placeholder: "",
                            },
                            on: { change: _vm.onRegionChange },
                          }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-item" }, [
                    _c("label", { staticClass: "emphasis" }, [
                      _vm._v(_vm._s(_vm.$t("user.profile.defaultLanguage"))),
                    ]),
                    _vm._v(" "),
                    _vm.langOptions.length > 1
                      ? _c(
                          "div",
                          [
                            !_vm.isEdit
                              ? _c("span", { staticClass: "label-content" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customLangLabel(_vm.selectedLang)
                                    )
                                  ),
                                ])
                              : _c("HKLSelect", {
                                  attrs: {
                                    value: _vm.selectedLangId,
                                    options: _vm.langHklOptions,
                                    showSearch: true,
                                    placeholder: "",
                                  },
                                  on: { change: _vm.onLangChange },
                                }),
                          ],
                          1
                        )
                      : _vm.langOptions.length === 1
                      ? _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.customLangLabel(_vm.langOptions[0])) +
                              "\n            "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ],
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "profile-dashboard" }, [
          _c("div", { staticClass: "profile-section-title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("user.profile.dashboardSettings")) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "profile-item" }, [
            _c("label", { staticClass: "emphasis" }, [
              _vm._v(_vm._s(_vm.$t("user.profile.defaultDashboard"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "label-content" }, [
              _vm._v(
                _vm._s(_vm.customDashboardLabel(_vm.selectedDashboardOption))
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }